export default __webpack_public_path__ + "static/avatar-kortical-team1--mobile-8567533499bcd223489de66974506b2c.webp";